import React from 'react';
import ReactDOM from 'react-dom';
import { T } from '../../../../../../common/locale/translate';

export default class OfferType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      pristine: true,
      value: '',
      values: [
        { name: T('holiday'), code: 'A' },
        { name: T('hotel_only'), code: 'S' }
      ],
      offer_type: props.offer_type
    };
  }

  componentDidMount() {
    let value = this.state.values.filter(
      offer_type => offer_type.code == this.state.offer_type
    );
    value = value.length ? value[0].name : '';
    this.setState({ active: false, value });
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  }

  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.rating_min != 'undefined' && this.state.pristine) {
      this.setState({ offer_type: nextProps.offer_type, pristine: false });
    }
  }

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  }

  render() {
    return (
      <div
        className={
          'offer_type select-wrapper animated-text-form extended ' +
          (this.state.active ? 'active' : '')
        }
        ref={() => {
          this.returnSearchedValue = this.returnSearchedValue.bind(this);
        }}
      >
        <label className="animated-text-label">
          <span className="animated-text-label-name">{this.props.title}</span>
        </label>
        <i className="dropdown-icon fa fa-chevron-down" />
        <input
          type="text"
          value={this.state.value}
          className="animated-text-input offer-input"
          readOnly
          onFocus={this.handleFocus}
        />
        <div className="dropdown-menu">
          <i className="fa fa-times close-icon" onClick={this.handleClose} />
          <ul className="dropdown-wrapper">{this.renderCheckboxes()}</ul>
        </div>
      </div>
    );
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if ((!domNode || !domNode.contains(event.target)) && this.state.active) {
      this.setState({ active: false });
    }
  };

  handleChange = event => {
    let value = this.state.values.filter(
      offer_type => offer_type.code == event.target.value
    )[0].name;
    this.setState({ offer_type: event.target.value, active: false, value });
  };

  handleClose = () => {
    this.setState({ active: false });
  };

  handleFocus = () => {
    this.setState({ active: true });
  };

  renderCheckboxes = () => {
    return this.state.values.map(offer => {
      const isChecked = this.state.offer_type == `${offer.code}`;
      return (
        <li key={`offer_${offer.code}`} className="item">
          <input
            type="radio"
            id={`offer_${offer.code}`}
            name="offer"
            onChange={this.handleChange}
            value={offer.code}
            checked={isChecked}
          />
          <label htmlFor={`offer_${offer.code}`}>{offer.name}</label>
        </li>
      );
    });
  };

  returnSearchedValue = () => {
    return this.state.offer_type !== 0 ? this.state.offer_type : false;
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/offer_variants/offer_type.js